import {SFuncModal} from "shj-components";
import {Cascader, Form, Select, Spin} from "antd";
import {useEffect, useMemo, useState,} from "react";
import {useRequest} from "ahooks";
import {addChannelRoleRef, editChannelRoleRef, getRoleListFn} from "@/services/member.ts";
import {getChannels} from "@/services/getUsers.ts";
import arrToListOption from "@/utils/arrToListOption.tsx";
import {isArray} from "lodash-es";
import {getSalesTemplateList} from "@/services/customerServices.ts";

type EditOption = {
    title: string,
    data?: any
    destroy: (success: boolean) => void;
}

// 根据id找树形数组上级
function findAllParents(tree, targetId) {
    const parents = [];
    function traverse(node) {
        if (node.id === targetId) {
            parents.push(node);
            return true;
        }
        if (node.children) {
            for (const child of node.children) {
                if (traverse(child)) {
                    parents.push(node);
                    return true;
                }
            }
        }
        return false;
    }
    for (const root of tree) {
        traverse(root);
    }
    return parents.reverse(); // 反转数组以确保从根节点到目标节点的顺序
}

export function openEdit(option: EditOption) {
    const destroy = (success) => {
        modal.destroy();
        option.destroy(success)
    }
    const modal = SFuncModal({
        content: (<EditContent destroy={destroy} data={option.data}/>),
        title: option.title,
        vanish: true,
    });
}
function EditContent(props: any) {
    const [loading,setLoading]= useState(false);
    const [form] = Form.useForm();
    const {data: channelTree}: any = useRequest(getChannels, {});
    const {data: roleList}: any = useRequest(getRoleListFn, {
        defaultParams:[{data: { enabled: true }}]
    });
    const [saleTemplateList, setSaleTemplateList] = useState([])

    useEffect(() => {
        getOptions()
    }, []);
    const channelIdsArr = useMemo(() => findAllParents(channelTree || [],props.data?.channelId), [channelTree,props.data]);

    const getOptions = async() => {
        const saleTemplateList = await getSalesTemplateList({"templateType":"CLUE", enable: true})
        setSaleTemplateList(saleTemplateList)
    }

    useEffect(() => {
        form.resetFields();
        const data = props.data || {};
        form.setFieldsValue({
            ...data,
            channelIds: (channelIdsArr || []).map(item => item?.id)
        });
    }, [props.data,channelTree])

    const onOk = () => {
        form.validateFields().then(values => {
            const {channelIds,...rest} = values || {};
            const channelId = isArray(channelIds)&&channelIds?.length>0?channelIds[channelIds?.length-1]:'';
            const apiUrl = props.data?.id ? editChannelRoleRef : addChannelRoleRef;
            setLoading(true)
            apiUrl({
                ...rest,
                channelId,
                id:props.data?.id||""
            }).then(res => {
                props.destroy(true);
            }).finally(() => {
                setLoading(false);
            });
        })
    }

    return (
        <SFuncModal.Content onOk={onOk} onCancel={() => props.destroy(false)} confirmLoading={loading} >
            <Spin spinning={loading}>
                <Form form={form} layout='vertical'>
                    <Form.Item label='渠道名称' name='channelIds' rules={[{required: true}]}>
                        <Cascader
                            showSearch
                            expandTrigger="hover"
                            options={channelTree}
                            allowClear={true}
                            disabled={props.data?.id}
                            placeholder={'请选择渠道名称'}
                        />
                    </Form.Item>
                    <Form.Item label='关联角色' name='roleIds' rules={[{required: true}]}>
                        <Select
                            placeholder="请选择"
                            mode="multiple"
                            showSearch
                            allowClear={true}
                            optionFilterProp='children'
                        >
                            {arrToListOption(roleList,{value: 'id', title: 'name'})}
                        </Select>
                    </Form.Item>
                    <Form.Item label='商机计划' name='salesTemplateId'>
                        <Select
                            placeholder="请选择"
                            showSearch
                            allowClear={true}
                            optionFilterProp='children'
                        >
                            {saleTemplateList.map(item => (<Select.Option value={item.id}>{item.id + '' + item.name}</Select.Option>))}
                        </Select>
                    </Form.Item>
                </Form>
            </Spin>
        </SFuncModal.Content>
    )
}

